<div fxLayout="row" fxLayoutAlign="start start" fxFlex.gt-sm="100">
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="30" class="m-r-5">
        <fieldset class="actionType-panel">
            <legend>Tipos de Actuación</legend>
            <app-action-type-tree-view (activityTypeSelect)="setSelectedActivityType($event, true)"
                (activityTypeDeselect)="setSelectedActivityType($event, false)"></app-action-type-tree-view>
        </fieldset>
    </div>
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="70" class="dis-block">
        <fieldset>
            <legend>Gestión</legend> 
            <mat-form-field class="mr-20 ">
                <mat-label>Coordinador de la empresa</mat-label>
                <mat-select class="full-width-multi-select" [(ngModel)]="filterServcie.EmpresaCoordinador"
                    (ngModelChange)="SetFilterValues('EmpresaCoordinador')">
                    <mat-option *ngFor="let Cordinadr of filterServcie.CoordinadorList$" [value]="Cordinadr.viewValue">
                        {{Cordinadr.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="mr-20 ">
                <mat-label>Gestor de la empresa</mat-label>
                <mat-select class="full-width-multi-select" [(ngModel)]="filterServcie.Gestor"
                    (ngModelChange)="SetFilterValues('Gestor')">
                    <mat-option *ngFor="let Gestor of filterServcie.GestorList$" [value]="Gestor.administrativa">
                        {{Gestor.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </fieldset>
        <fieldset>
            <legend>Registro</legend>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
                <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.Registro"
                    [PeriodFrom]="filterServcie.CommonDateFrom" [PeriodTo]="filterServcie.CommonDateTo"
                    (FromDateChanged)="SetFilterValues('commonDateFrom', $event)"
                    (ToDateChanged)="SetFilterValues('commonDateTo', $event)"></app-date-period-filter>

                <mat-form-field *ngIf="selectionService.selectionPermissions.HasUsuario">
                    <mat-label>Usuario</mat-label>
                    <mat-select class="full-width-multi-select" [(ngModel)]="filterServcie.Usuario"
                        (ngModelChange)="SetFilterValues('Usuario')">
                        <mat-option *ngFor="let usuar of filterServcie.UsuarioList$" [value]="usuar.viewValue">
                            {{usuar.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </fieldset>

        <!-- Review -->
        <fieldset>
            <legend>Revision</legend>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
                <app-date-period-filter *ngIf="selectionService.selectionPermissions.HasFechaRevision"
                    [IsBothDatesRequired]="false" [DateType]="DateFilterType.FechaRevision"
                    [PeriodFrom]="filterServcie.FechaRevisionDateFrom" [PeriodTo]="filterServcie.FechaRevisionDateTo"
                    (FromDateChanged)="SetFilterValues('FechaRevisionDateFrom', $event)"
                    (ToDateChanged)="SetFilterValues('FechaRevisionDateTo', $event)"></app-date-period-filter>

                <mat-form-field *ngIf="selectionService.selectionPermissions.HasFechaRevision">
                    <mat-label>Coordinador</mat-label>
                    <mat-select class="full-width-multi-select" [(ngModel)]="filterServcie.Coordinador"
                        (ngModelChange)="SetFilterValues('Coordinador')">
                        <mat-option *ngFor="let Cordinadr of filterServcie.CoordinadorList$"
                            [value]="Cordinadr.viewValue">
                            {{Cordinadr.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
                <mat-checkbox *ngIf="selectionService.selectionPermissions.HasFechaRevision"
                    [(ngModel)]="filterServcie.Revisadas" (ngModelChange)="SetFilterValues('Revisadas')" class="mr-20">
                    Revisadas
                </mat-checkbox>
                <mat-checkbox *ngIf="selectionService.selectionPermissions.HasFechaRevision"
                    [(ngModel)]="filterServcie.ConComentarios" (ngModelChange)="SetFilterValues('ConComentarios')"
                    class="mr-20">Con
                    comentarios</mat-checkbox>
                <mat-checkbox *ngIf="selectionService.selectionPermissions.HasFechaRevision"
                    [(ngModel)]="filterServcie.ConOrdenes" (ngModelChange)="SetFilterValues('ConOrdenes')">Con
                    ordenes
                </mat-checkbox>
            </div>
        </fieldset>

        <fieldset>
            <legend>Baja</legend>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
                <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.PeriodoDeBaja"
                    [PeriodFrom]="filterServcie.PeriodoDeBajaDateFrom" [PeriodTo]="filterServcie.PeriodoDeBajaDateTo"
                    (FromDateChanged)="SetFilterValues('PeriodoDeBajaDateFrom', $event)"
                    (ToDateChanged)="SetFilterValues('PeriodoDeBajaDateTo', $event)"></app-date-period-filter>

                <app-leave-type-filter [LeaveTypeControl]="filterServcie.ActuationLeaveType"
                    (LeaveTypeSelected)="SetLeaveType($event)">
                </app-leave-type-filter>

            </div>
        </fieldset>

        <!-- Facturacion -->
        <fieldset class="facturaction-panel">
            <legend>Facturacion</legend>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
                <div fxLayout="column">
                    <div fxFlex.gt-sm="100" fxFlexAlign="center">
                        <mat-radio-group aria-label="Select an option" layout="row"
                            [(ngModel)]="filterServcie.FacturacionRadioButton"
                            (ngModelChange)="SetFilterValues('FacturacionRadioButton')">
                            <mat-radio-button value="Todas" class="md-primary">Todas</mat-radio-button>
                            <mat-radio-button value="Pendientes" class="ml-20">Pendientes</mat-radio-button>
                            <mat-radio-button value="Facturadas" class="ml-20">Facturadas</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div fxFlex.gt-sm="20" fxFlexAlign="center" class="m-t-10">
                    <mat-checkbox [(ngModel)]="filterServcie.IsConceptosFacturables"
                        (ngModelChange)="SetFilterValues('ConceptosFacturables')" class="ml-20">
                        Conceptos facturables
                    </mat-checkbox>
                </div>
            </div>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100" class="mt-8">
                <fieldset>
                    <legend>Fra. Centro</legend>
                    <div fxLayout="column">
                        <div fxFlex.gt-sm="100" fxFlexAlign="center">
                            <mat-radio-group aria-label="Select an option" layout="row"
                                [(ngModel)]="filterServcie.FacturacionFraCentro"
                                (ngModelChange)="SetFilterValues('FacturacionFraCentro')">
                                <mat-radio-button value="Todas" class="md-primary">Todas</mat-radio-button>
                                <mat-radio-button value="SinFactura" class="ml-20">SinFactura</mat-radio-button>
                                <mat-radio-button value="ConFactura" class="ml-20">ConFactura</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
            </div>
        </fieldset>

        <fieldset class="actuation-attributes">
            <legend>Trabajador</legend>
            <app-attributes-filter [AttributeModal]="filterServcie.ActuationSelectedAttribute"
                (AttributeSelected)="SetAttribute($event)" (AttributeModalChanged)="SetAttributeModal($event)">
            </app-attributes-filter>

            <mat-form-field appearance="outline">
            <mat-label>Provincia</mat-label>
            <mat-select 
              name="provinciaSelect"
              [(ngModel)]="this.actuationSelection.Provincia"  [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onProvinciaChange($event)">
              
              <div class="buscador-container">
                <input class="buscador-input" placeholder="Buscar provincia..." 
                      (input)="filtrarProvincias($event)" 
                      (keydown)="$event.stopPropagation()">
              </div>

              @for (prov of filteredProvinceList; track prov.value) {
                <mat-option [value]="prov.value">{{ prov.viewValue }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Población</mat-label>
          <mat-select 
            name="poblacionSelect"
            [(ngModel)]="this.actuationSelection.Poblacion"  [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onPoblacionChange($event)">
            
            <div class="buscador-container">
              <input class="buscador-input" placeholder="Buscar población..." 
                    (input)="filtrarPoblaciones($event)" 
                    (keydown)="$event.stopPropagation()">
            </div>

            @for (pob of filteredPoblacionList; track pob) {
              <mat-option [value]="pob">{{ pob }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        
        </fieldset>
    </div>
</div>